import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import remoteControlExample from '../../../assets/img/remoteControl/remoteControlExample.png';
import { IntroductionContainer } from './styles';
import { useHistory } from 'react-router-dom';
import SelectPlataformContext from '../../../contexts/selectPlataform';
import { useContext } from 'react';

interface IntroRemoteControlModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const IntroRemoteControlModal: React.FC<IntroRemoteControlModalProps> = ({ isOpen, onClose }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { setSelectPlataform } = useContext(SelectPlataformContext);
  function onClickGoRemoteControl(): void {
    localStorage.setItem('choosePlataform', '/controle-inteligente');
    setSelectPlataform('/controle-inteligente');
    history.push('/controle-inteligente');
  }

  return (
    <ModalTemplate
      padding={24}
      isOpen={isOpen}
      onClose={onClose}
      centralizedText
      imageText={(
        <IntroductionContainer>
          <p>{t('personalizeSuaMaquinaControleInteligente')}</p>
          <img
            src={remoteControlExample}
            alt={t('exemploControleInteligente')}
            loading="lazy"
            height="216px"
            width="100%"
          />
        </IntroductionContainer>
      )}
      title={t('controleMaquinaSemEsforco')}
      button1={t('abrirControleInteligente')}
      button2={t('naoQueroVerIssoAgora')}
      button1Action={onClickGoRemoteControl}
      button2Action={onClose}
    />
  );
};
